import React from 'react';

const Review: React.FC = () => {
  return <div>Co-Contributions Review Step</div>;
};

export default Review;
